export default __webpack_public_path__ + "static/covid-d2fb9312f60d85a82b2bb6b1c0cd7680.png";